module.exports = function() {

    /**
     * Buttons && Modals
     */
    var $addPropertyViewingButton = $('#js-add-property-viewing-of-user'),
        $addPropertyViewingModal = $('#add-property-viewing-of-user'),
        $addLunchButton = $('#js-add-lunch'),
        $addLunchModal = $('#add-lunch');

    /**
     * Controllers
     */
    var PropertyViewingOfUserDataTable = new (require('./PropertyViewingOfUserDataTable'))(),
        PropertyViewingOfLettingAgentDataTable = new (require('./PropertyViewingOfLettingAgentDataTable'))(),
        PropertyViewingCalendarOfUserController = new (require('./PropertyViewingCalendarOfUserController'))(PropertyViewingOfUserDataTable, $addLunchModal),
        AddPropertyViewingController = new (require('./PropertyViewingController'))($addPropertyViewingModal, PropertyViewingCalendarOfUserController);

   PropertyViewingCalendarOfUserController.render();

    // Let show modal on button click
    $addPropertyViewingButton.click(function(e){
        AddPropertyViewingController.showModal();
        e.preventDefault();
    });

    $addLunchButton.click(function(e){
        PropertyViewingCalendarOfUserController.showLunchModal();
        e.preventDefault();
    });

}();